<template>
  <v-footer
    color="neutral25"
    class="px-4 px-md-12 py-4 text-neutral900 app-footer"
    :class="{ 'app-footer--inline': inline }"
    :app="!inline"
  >
    <div class="footer-content full-width">
      <AppFooterLinks />

      <v-row class="mt-3">
        <v-col cols="12" class="footer-activator d-flex align-center pt-0">
          <h4 class="text-body-2 text-neutral400">
            © {{ currentYear }} rubra ag
          </h4>
        </v-col>
      </v-row>
    </div>
  </v-footer>
</template>

<script setup>
import { computed } from 'vue'
import AppFooterLinks from './AppFooterLinks'

defineProps({
  // At the end of the page content instead of pinned to the bottom of the window
  inline: Boolean,
})

const currentYear = computed(() => new Date().getFullYear())
</script>

<style lang="scss" scoped>
.footer-content {
  width: 100%;
}

.footer-activator {
  padding-top: 0 !important;
}

// As wide as the window, like the fixed footer: it leaves the space v-main keeps
// for a permanent drawer (the public collection page's filter panel) and is drawn
// over that drawer, whose layout z-index is 1004. Only from md up: below that the
// filter panel is a bottom sheet, which has to stay on top of the footer.
.app-footer--inline {
  margin-left: calc(-1 * var(--v-layout-left, 0px));
  margin-right: calc(-1 * var(--v-layout-right, 0px));
  // A hairline to the page above: on the detail pages both have the same background
  border-top: 1px solid rgb(var(--v-theme-neutral50));

  @include md-up {
    z-index: 1005;
  }
}
</style>
